export default {
  "t-physical-examination": "体检",
  "t-physical-examination-logs": "设备体检报告",
  "t-terminal-data-upload-configuration": "终端数据上传配置",
  "t-terminal-strategy-parameters": "终端策略参数",
  "t-strategy-execution-report": "策略执行报告",
  "t-terminal-data-analysis": "终端数据分析",
  "t-configuration-parameters": "配置参数",
  "t-data-alert-config": "数据与警报配置",
  "t-data-upload-alert-event-config": "数据上传与警报事件配置",
  "t-history": "历史",
  "t-health-check-date": "体检日期",
  "t-health-score": "健康分数",
  "t-check-items": "检测项",
  "t-pass-rate": "通过率",
  "t-detection-status": "硬件检测项状态",
  "t-device-basic-info": "设备基本信息",
  "t-healthy": "健康",
  "t-optimal": "正常",
  "t-unhealthy": "不健康",
  "t-skip": "跳过",
  "t-printer": "打印机",
  "t-voltage": "电压",
  "t-temperature": "温度",
  "t-charging-status": "充电状态",
  "t-print-distance": "打印距离",
  "t-print-head-size": "打印头尺寸",
  "t-bootloader-version": "引导加载程序版本",
  "t-internal-software-version": "内部软件版本",
  "t-uptime": "正常运行时间",
  "t-detection-content": "总共测试了 {total} 项，通过 {pass} 项，跳过 {skip} 项",
  "t-not-charging": "未充电",
  "t-charging": "充电中",
  "t-closed": "已关闭",
  "t-opened": "已打开",
  "t-mobile-data": "移动数据",
  "t-wifi": "WIFI",
  "t-unknown": "未知",
  "t-medical-inspection": "体检类型",
  "t-health-status": "健康状态",
  "t-manual": "手动",
  "t-automatic": "自动",
  "t-manual-physical-examination-type": "人工",
  "t-automatic-physical-examination-type": "自动",
  "t-device-data-acquisition": "设备数据采集",
  "t-device-data-stop-collection": "设备数据停止采集",
  "t-device-health-check": "设备健康检查",
  "t-auto-health-check": "自动健康检查",
  "t-tha-logs": "THA 健康检查日志",
  "t-battery-brand": "品牌",
  "t-battery-mfg-date": "生产日期",
  "t-charging-duration": "充电持续时间",
  "t-charging-current": "充电电流",
  "t-charge-cycles": "充电周期",
  "t-charge-cycle-count": "充电周期计数",
  "t-low-temperature-warning-count": "低温警告计数",
  "t-low-temp-shutdown-count": "低温关机次数",
  "t-high-temperature-warning-count": "高温警告计数",
  "t-high-temp-shutdown-count": "高温关机次数",
  "t-data-upload": " THA 数据上传列表",
  "t-alert-event": "THA 警报事件",
  "t-device-config": "THA 设备策略",
  "t-config-sync-log": "THA 配置同步日志",
  "t-event-trigger-time": "事件触发时间",
  "t-event-upload-time": "事件上送时间",
  "t-battery-overheating": "电池高温告警",
  "t-battery-undervoltage": "电池低温告警",
  "t-cpu-overheating": "电池高温关机",
  "t-event-battery-high-temperature": "电池高温预警",
  "t-event-battery-low-temperature": "电池低温预警",
  "t-event-cpu-high-temperature": "CPU高温",
  "t-event-battery-high-temperature-shutdown": "电池高温关机",
  "t-event-battery-low-temperature-shutdown": "电池低温关机",
  "t-event-type": "事件类型",
  "t-total-records": "总记录数",
  "t-peripheral": "外围设备",
  "t-module": "模块",
  "t-sampling-period": "采样周期",
  "t-sampling-period-1-minute": "1分钟",
  "t-sampling-period-3-minutes": "3分钟",
  "t-sampling-period-5-minutes": "5分钟",
  "t-sampling-period-10-minutes": "10分钟",
  "t-sampling-period-30-minutes": "30分钟",
  "t-sampling-period-60-minutes": "60分钟",
  "t-upload-interval": "上传周期",
  "t-upload-interval-less-than-sampling-period": "上传周期不能小于采样周期",
  "t-sample-count": "样本计数",
  "t-valid-sample-count": "有效样本计数",
  "t-upload-timestamp": "上传时间",
  "t-sample-timestamp": "最新上报时间",
  "t-config-sync-logs": "THA 配置同步日志",
  "t-data-point": "数据点",
  "t-policy-updated": "策略已更新",
  "t-policy-consistent": "策略一致",

// 应用信息
  "t-app-name": "应用名称",
  "t-package-name": "包名",
  "t-is-system": "是否系统应用",
  "t-app-version": "应用版本",
  "t-authorisations": "授权",
  "t-installed-at": "安装于",
  "t-app-size": "大小",
// 网络流量统计
  "t-uplink-traffic": "上行流量",
  "t-downlink-traffic": "下行流量",
  "t-traffic-total": "总流量",
  "t-monitor-more": "更多",
// 网络连接状态
  "t-router-name": "路由器名称",
// 外设使用统计
  "t-swipe-card-count": "刷卡次数",
  "t-insert-card-count": "插卡次数",
  "t-tap-card-count": "贴卡次数",
  "t-card-fail-count": "卡片交易失败次数",
  "t-print-mileage": "打印距离",
  "t-print-speed": "打印速度",
  "t-print-grayscale": "打印灰度",

  "t-open-tha-model-waiting": "THA 请求已启动，请等待 ..",
  "t-manually-initiated-health-check-failed": "手动发起健康检查失败",
  "t-health-check-initialization-failed": "健康检查初始化失败",
  "t-manually-initiated-health-check-success": "发起健康检查成功，请在设备检查报告中查看",
  "t-monitor-abnormal": "异常",
  "t-monitor-start-date": "开始日期",
  "t-monitor-end-date": "结束日期",
  "t-monitor-battery-status": "电池状态",
  "t-monitor-battery-health": "电池健康度",
  "t-monitor-current-capacity": "电池电量",
  "t-monitor-current-capacity-percent": "容量百分比",
  "t-monitor-mcu-backup-power": "MCU备电",
  "t-monitor-mcu-backup-status": "备电状态",
  "t-monitor-key-focus": "重点关注",
  "t-monitor-battery-trend": "电池趋势",
  "t-monitor-temperature-battery-threshold": "温度阈值 / 电量阈值",
  "t-monitor-system-resource-trend": "系统资源趋势",
  "t-monitor-storage-high": "存储偏高",
  "t-monitor-network-traffic-trend": "网络与流量趋势",
  "t-monitor-link-stable": "链路稳定",
  "t-monitor-data-summary": "数据统计汇总",
  "t-monitor-metric": "指标",
  "t-monitor-current-value": "当前值",
  "t-monitor-minimum-value": "最小值",
  "t-monitor-maximum-value": "最大值",
  "t-monitor-average-value": "平均值",
  "t-threshold": "阈值",
  "t-monitor-unit-times": "次",
  "t-monitor-unit-meter": "米",
  "t-monitor-no-sampling-time": "暂无采样时间",
  "t-monitor-device-info": "设备信息",
  "t-monitor-software-version": "软件版本",
  "t-monitor-sma-version": "SMA版本",
  "t-monitor-pos-service": "POS服务",
  "t-monitor-network-connection": "网络连接",
  "t-monitor-ip-address": "IP地址",
  "t-monitor-mac-address": "MAC地址",
  "t-monitor-battery-info": "电池信息",
  "t-monitor-battery-brand": "电池品牌",
  "t-monitor-collection-summary": "采集摘要",
  "t-monitor-valid-rate": "有效率",
  "t-monitor-battery-level": "电量",
  "t-monitor-current": "电流",
  "t-monitor-over-threshold": "超阈值",
  "t-monitor-below-threshold": "低于阈值",
  "t-monitor-idle": "空闲",
  "t-monitor-charge-cycle-stats": "充电循环统计",
  "t-monitor-high": "偏高",
  "t-monitor-charge-count": "充电次数",
  "t-monitor-cumulative": "累计",
  "t-monitor-current-cycle": "当前周期",
  "t-monitor-high-temperature-warning": "高温告警",
  "t-monitor-high-temp-shutdown": "高温关机",
  "t-monitor-severe": "严重",
  "t-monitor-controllable": "可控",
  "t-monitor-low-temperature-warning": "低温告警",
  "t-monitor-low-temp-shutdown": "低温关机",
  "t-monitor-system-resource": "系统资源",
  "t-monitor-network-signal": "网络信号",
  "t-monitor-weak": "较弱",
  "t-monitor-good": "良好",
  "t-monitor-stable": "稳定",
  "t-monitor-application-traffic": "应用流量",
  "t-monitor-current-sample": "本次采样",
  "t-monitor-peripheral-stats": "外设统计",
  "t-monitor-need-attention": "需关注",
  "t-monitor-usage": "使用率",
  "t-monitor-ethernet": "以太网",
  "t-monitor-link-normal": "链路正常",
  "t-monitor-fetch-failed": "获取监控数据失败",
  "t-version-change-timeline": "软件版本变更时间线",
  "t-version-change-count": "{count} 次版本变更",
  "t-version-timeline-empty": "暂无版本变更记录",
  "t-version-timeline-multiple-events": "多事件",
  "t-version-timeline-event": "事件",
  "t-version-timeline-init": "初始化",
  "t-version-timeline-update": "版本更新",
  "t-version-timeline-upgrade": "升级",
  "t-version-timeline-rollback": "回滚",
  "t-version-timeline-exception": "异常",
  "t-version-timeline-current": "当前",
  "t-data-upload-data": "THA 数据概览",
  "t-tha-data-overview": "THA 数据概览",
  "t-manual-physical-examination-and-automatic-physical-examination": "人工体检时，设备需要安装POS Manager，此应用用于检测显示屏、触摸屏、相机、扬声器、按键、指纹、麦克风、磁条读卡器、芯片读卡器、非接触读卡器、打印机、状态指示灯、蜂鸣器、支付安全存储模块，其中也包含自动体检项：设备序列号、体检时间、蓝牙状态、CPU 目前使用量、运行内存目前使用量、存储内存目前使用量、已开机时间、定位、充电状态、电池温度、电池电压、电池电量、通信类型、信号类型、路由器地址、传输速度、WiFi MAC 地址、信号强度、网络开关、打印距离",
  "t-manual-physical-examination-and-automatic-physical-examination-auto": "自动体检时，设备不需要安装POS Manager，此应用用于检测设备序列号、体检时间、蓝牙状态、CPU 目前使用量、运行内存目前使用量、存储内存目前使用量、已开机时间、定位、充电状态、电池温度、电池电压、电池电量、通信类型、信号类型、路由器地址、传输速度、WiFi MAC 地址、信号强度、网络开关、打印距离",
  "t-power-level": "电量",
}
